import { isEmpty } from 'lodash-es';

export function isObject(maybeObject: unknown) {
  return typeof maybeObject === 'object' && !Array.isArray(maybeObject) && maybeObject !== null;
}

/**
 * Type guard for a plain object (not null, not an array). Narrows `unknown` to
 * `Record<string, unknown>` so callers can read keys without a cast.
 */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isEmptyOrEmptyObject(object: unknown) {
  if (!isRecord(object)) {
    return isEmpty(object);
  }

  return Object.keys(object).length === 0;
}

/**
 * The value stored under `key` on the record itself, never one it inherits:
 * a key read from data may be `constructor` or `toString`.
 */
export function ownValue<Value>(record: Readonly<Record<string, Value>>, key: string): Value | undefined {
  return Object.hasOwn(record, key) ? record[key] : undefined;
}
